export function isAuthenticated() {
	return !! sessionStorage.getItem('currentUser')
}

export function getCurrentUser() {
	const userStr = localStorage.getItem('currentUser')
	if (userStr) {
		try {
			return JSON.parse(userStr)
		} catch (e) {
			console.error('Failed to parse user data:', e)
			return null
		}
	}
	return null
}

export function saveUser(userData) {
	localStorage.setItem('currentUser', JSON.stringify(userData))
}

export function removeUser() {
	localStorage.removeItem('currentUser')
}

export function getUserCoins(userId) {
	const coins = localStorage.getItem(`user_coins_${userId}`)
	return coins ? parseInt(coins) : 1000
}

export function saveUserCoins(userId, coins) {
	localStorage.setItem(`user_coins_${userId}`, coins)
}